"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = require("react");
var styled_components_1 = require("styled-components");
var SituationSelectModal_1 = require("../SituationSelectModal");
var descriptionOf = {
    presentee: "贈る相手を選んでください",
    age: "贈る相手の年代を選んでください",
    occasion: "贈る目的・イベントを選んでください"
};
exports.SituationSelectDescriptor = function (props) {
    var description = props.state === SituationSelectModal_1.ModalState.Presentee
        ? descriptionOf.presentee
        : props.state === SituationSelectModal_1.ModalState.Age
            ? descriptionOf.age
            : props.state === SituationSelectModal_1.ModalState.Occasion
                ? descriptionOf.occasion
                : descriptionOf.presentee;
    return React.createElement(Descriptor, null, description);
};
var Descriptor = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 5px 10px;\n  position: absolute;\n  overflow: auto;\n  width: 100%;\n  height: 30px;\n  top: 70px;\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  padding: 5px 10px;\n  position: absolute;\n  overflow: auto;\n  width: 100%;\n  height: 30px;\n  top: 70px;\n  font-size: 14px;\n  line-height: 20px;\n"])));
var templateObject_1;
